import { API_BASE_URL } from "@config";
import axios from "@config/axios";
import queryString from "query-string";
import { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import { useMutation } from "react-query";
import { useLocation, useNavigate, useParams } from "react-router-dom";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  /** */

  // Axios Interceptor Ref
  const interceptorRef = useRef(null);

  const navigate = useNavigate();

  // Token State
  const [token, setToken] = useState(null);

  // Get Company ID
  const { company } = useParams();

  // Authorize Axios
  const authorize = useCallback((token) => {
    if (interceptorRef.current !== null) axios.interceptors.request.eject(interceptorRef.current); // Remove Existing Interceptor
    interceptorRef.current = axios.interceptors.request.use(
      (config) => {
        config.headers["authorization"] = `Bearer ${token}`;
        return config;
      },
      (error) => Promise.reject(error)
    );
  }, []);

  // De-Authorize Axios
  const deAuthorize = useCallback(() => {
    if (interceptorRef.current !== null) {
      axios.interceptors.request.eject(interceptorRef.current); // Remove Existing Interceptor
      interceptorRef.current = null;
    }
  }, []);

  // Check Parent URL
  const IFrameQueries = queryString.parse(useLocation().search);
  const parentURL = IFrameQueries?.parentUrl; // Received as a Query from Containgin Iframe
  const locale = IFrameQueries?.locale; // Received as a Query from Containgin Iframe

  // Check Visitor Mutation
  const CVM = useMutation(
    async () => {
      const response = await axios.post(`${API_BASE_URL}/${company}/visitor/check`, {
        token: localStorage.getItem("token"),
        page: {
          URL: parentURL,
        },
        locale,
      });
      return response;
    },
    {
      onSuccess: (response) => {
        if (response?.token) {
          localStorage.setItem("token", response.token); // Persist Token in LocalStorage
          setToken(response.token); // Persist Token in Context
          // if (response?.contactRequired) navigate(`/${company}/messenger/contact`, { replace: true }); // Contact Information Required
          navigate(`/${company}/messenger/chat`, { replace: true }); // Chat Page
        }
      },
      onError: (error) => {
        return console.log(error);
      },
    }
  );

  // Check Visitor
  useEffect(() => {
    if (company) CVM.mutate();
  }, [company]);

  // Authorize Axios
  useEffect(() => {
    if (token) authorize(token);
    else deAuthorize();
    return () => deAuthorize();
  }, [token]);

  // Make CDN URL
  const makeCDNURL = (URL = "") => {
    const hasQuery = URL.includes("?");
    return `${URL}${hasQuery ? "&" : "?"}token=${token}`;
  };

  return <AuthContext.Provider value={{ token, makeCDNURL }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
